<template>
    <div>
        <div class="spacer-40"></div>
        <div class="part-line"></div>
        <div class="main-title">Your Referral</div>
        <div class="spacer-40 pc-mode"></div>
        <div class="spacer-20 mb-mode"></div>
        <div class="link-txt">
            <span>https://playripple.net/user-linked-account</span>
            <a href="" onclick="javascript: return false;" v-on:click="copyLink()">Copy Link</a>
        </div>
        <div class="spacer-30"></div>
        <div class="component" style="position:relative;">
            <table class="normal-tb rowclick-tb">
                <thead>
                <tr>
                    <th>RefNo</th>
                    <th>User ID</th>
                    <th>Investment</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="referral in list" v-bind:key="referral.mem_uuid" @click="showPersonDetail(referral.mem_uuid)">
                    <td>#{{referral.rownum}}</td>
                    <td class="id-txt">{{referral.mem_uuid}}</td>
                    <td>{{referral.xrp_income_amt}} XRP</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="row">
            <modal :show.sync="modals.notificationShow"
                   gradient="danger"
                   modal-classes="modal-warning modal-dialog-centered modal-title-notification">
                <h6 slot="header" class="modal-title" id="modal-title-notification">Your attention is required</h6>

                <div class="py-3 text-center">
                    <i class="ni ni-bell-55 ni-3x"></i>
                    <h4 class="heading mt-4">{{ notificationMessage }}</h4>
                </div>

                <template slot="footer">
                    <!--<base-button type="white">Ok, Got it</base-button>-->
                    <base-button type="link"
                                 text-color="white"
                                 class="ml-auto"
                                 @click="modals.notificationShow = false">
                        Close
                    </base-button>
                </template>
            </modal>
            <modal :show.sync="modals.info"
                   modal-classes="modal-info modal-dialog-centered modal-title-notification">
                <h6 slot="header" class="modal-title" id="modal-title-confirmation">Your referral address</h6>
                <p>
                    {{ infoMessage }}
                </p>
                <p>Copied link to clipboard</p>
                <template v-slot:footer>
                    <base-button
                            type="link"
                            text-color="white"
                            class="ml-auto"
                            @click="modals.info = false"
                    >Close</base-button>
                </template>
            </modal>
            <modal :show.sync="modals.personal"
                   modal-classes="modal-detail modal-dialog-centered ">
                <p>User ID : {{ this.mem_uuid }}</p>
                <div class="spacer-10"></div>
                <div class="body-normal">
                    <div class="pop-id-box">
                        <div class="pop-id-box-in">
                            <div>
                                Total Package Income<br/>
                                Amount<br/>
                                {{this.personDetail.total_deposit}} XRP
                            </div>
                        </div>
                        <div class="pop-id-box-in">
                            <div>
                                Withdrawal<br/>
                                Amount<br/>
                                {{this.personDetail.total_withdrawal}} XRP
                            </div>
                        </div>
                        <div class="pop-id-box-in">
                            <div>
                                Reinvestment<br/>
                                Amount<br/>
                                {{this.personDetail.reinvestment_amount}} XRP
                            </div>
                        </div>
                        <div class="pop-id-box-in">
                            <div>
                                Referral<br/>
                                Amount<br/>
                                {{this.personDetail.total_referral}} XRP
                            </div>
                        </div>
                        <div class="pop-id-box-in">
                            <div>
                                Upline<br/>
                                Amount<br/>
                                {{this.personDetail.upline_income}} XRP
                            </div>
                        </div>
                        <div class="pop-id-box-in">
                            <div>
                                Downline<br/>
                                Amount<br/>
                                {{this.personDetail.downline_income}} XRP
                            </div>
                        </div>
                        <div class="pop-id-box-in">
                            <div>
                                Withdrawable<br/>
                                Amount<br/>
                                {{this.personDetail.total_balance}} XRP
                            </div>
                        </div>
                        <!--<div class="pop-id-box-in">
                            <div>
                                Registration NO<br/>
                                #{{this.personDetail.mem_level}}
                            </div>
                        </div>-->
                    </div>
                </div>
                <template v-slot:footer>
                    <base-button
                            type="link"
                            text-color="white"
                            class="ml-auto"
                            @click="modals.personal = false"
                    >Close</base-button>
                </template>
            </modal>
        </div>
    </div>
</template>
<style>
    .modal-detail p {
        font-size: 16px;
        font-weight: bold;
        color: #fff;
    }
</style>

<script>
import Modal from "@/components/Modal.vue";
import {mapGetters} from "vuex";
import axios from "../../service/axios";
export default {
    components: {
        Modal
    },
    data: () =>{
        return {
            mem_uuid : '',
            personDetail : {},
            list : {},
            isLoading: false,
            modals: {
                notificationShow: false,
                info: false,
                personal: false,
            },
            notificationMessage : '',
            infoMessage: '',
        }
    },
    computed: {
        ...mapGetters(["isAuthenticated"]),
        ...mapGetters(["user"]),
    },
    watch: {
        '$store.state.isAuthenticated': function() {
            // state에서 상태변화를 모니터링 한다.
            if (!this.isAuthenticated) {
                // 로그아웃으로 변화했다.
                this.list = {}
            }
        }
    },
    mounted() {
        if (!this.isAuthenticated) {
            this.list = {}
            return;
        }
        // 내 라인에 속한 유저들 리스트를 보여주면 된다.
        axios
            .post("/users/v1/referral/list")
            .then(response => {
                if (response.status === 200) {
                    this.list = response.data;
                }
            })
            .catch(error => {
                console.log(error)
                this.list = {}
            })
    },
    methods: {
        showPersonDetail : function (mem_uuid) {
            if (this.isLoading === true) {
                return;
            }
            this.mem_uuid = mem_uuid;
            this.isLoading = true;
            const data = {
                person_id : mem_uuid,
            };
            if (this.isAuthenticated) {
                // JWT-Token Expired check
                axios
                    .post("/auth/v1/verifyToken")
                    .then(response => {
                    })
                    .catch(error => {
                        console.log(error)
                    });
                axios
                    .post("/users/v1/user/detail", data)
                    .then(response => {
                        this.personDetail = response.data;
                        //console.log(this.personDetail);
                        this.modals.personal = true;
                        this.isLoading = false;
                    })
                    .catch(error => {
                        console.log(error.response)
                        this.notificationMessage = 'Fail to get detail information.';
                        this.modals.notificationShow = true;
                        this.isLoading = false;
                    });
            }
        },
        copyToClipboard : function (val) {
            const t = document.createElement("textarea");
            document.body.appendChild(t);
            t.value = val;
            t.select();
            document.execCommand('copy');
            document.body.removeChild(t);
        },
        copyLink : function () {
            if (!this.isAuthenticated) {
                this.notificationMessage = "You are not logged in. Please log in and try again";
                this.modals.notificationShow = true;
                return ;
            }
            const hostUrl = window.location.protocol + "//" + window.location.host;
            console.log(this.$store.getters.user);
            const referUrl = hostUrl + "/#/refer/" + this.$store.getters.user.share_key + "/" + this.$store.getters.user.center_code;
            // 클립보드로 COPY한다.
            this.copyToClipboard(referUrl);
            this.infoMessage = 'Copied : ' + referUrl;
            this.modals.info = true;
        }
    }
};
</script>
<style>
</style>
